import classNames from 'classnames';

export interface ErrorMessageProps {
  errors: any;
  touched: any;
  className?: string;
}

export function ErrorMessage({
  errors,
  touched,
  className,
}: ErrorMessageProps) {
  return (
    <span className={classNames('text-red-500', className)}>
      {(!!errors || !touched) && JSON.stringify(errors, null, 2)}
    </span>
  );
}

export default ErrorMessage;
